/**
 * Stable document identity for session-scoped chunk accumulation (#81).
 *
 * Must be deterministic: re-analysing the same text must address the same
 * gateway-side workspace so that re-sent chunks replace rather than duplicate.
 *
 * Requires a secure context (HTTPS / localhost) — crypto.subtle is
 * unavailable on plain HTTP origins.
 */
export async function computeDocumentId(text: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(text)
  );
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
